export default "__VITE_ASSET__BXh$8668__"